exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, "._31llzd_ZO15pHEZONwa96f{-webkit-box-align:center;-webkit-align-items:center;-moz-box-align:center;-ms-flex-align:center;align-items:center;cursor:pointer;display:-webkit-box;display:-webkit-flex;display:-moz-box;display:-ms-flexbox;display:flex;-webkit-box-orient:horizontal;-webkit-box-direction:normal;-webkit-flex-direction:row;-moz-box-orient:horizontal;-moz-box-direction:normal;-ms-flex-direction:row;flex-direction:row;font-size:.92857rem;-webkit-box-pack:center;-webkit-justify-content:center;-moz-box-pack:center;-ms-flex-pack:center;justify-content:center;line-height:100%;text-decoration:none;text-transform:uppercase;white-space:nowrap}._7I8_NvFUfuJ53Q8curfnO{margin-left:.71429rem}", ""]);

// exports
exports.locals = {
	"ArrowLink": "_31llzd_ZO15pHEZONwa96f",
	"ArrowLink_arrow": "_7I8_NvFUfuJ53Q8curfnO"
};


//////////////////
// WEBPACK FOOTER
// ../node_modules/css-loader?{"root":".","modules":true,"import":false,"importLoaders":1}!../node_modules/postcss-loader/lib?{"config":{"path":"/var/lib/jenkins/workspace/build-omni-operation-ui_develop/node_modules/omni-common-ui/postcss.config.js"}}!./components/ArrowLink/style.postcss
// module id = 1452
// module chunks = 0